import { Route, Switch, Router, Redirect } from "react-router-dom"
import { Main } from "./main"
import { Login } from "./login"
import { createBrowserHistory } from "history"
import { getCookie } from "../shared/helpers/cookie-helper"
import { Localization } from "./localization"
import "./custom-extensions"
import "antd/dist/antd.css"
import "./styles.less"
import "./global-style.css"

export const routerHistory = createBrowserHistory()

export const App = () => {
  const hash = getCookie("OutbackHash")
  return (
    <Router history={routerHistory}>
      <Localization>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route path="/:hash" component={Main} />
          <Route path="/">
            {hash ? <Redirect to={`/${hash}`} /> :
              <Redirect to="/login" />
            }
          </Route>
        </Switch>
      </Localization>
    </Router>
  )
}